import { type JSX, type PropsWithChildren } from 'react'
import { Modal, type ModalProps } from '@dhl-ui/components'
import { useNativeModalContext } from './NativeModalProvider.js'

type Props = PropsWithChildren<Pick<ModalProps, 'onClose' | 'onBack' | 'title' | 'isCloseable'>>

export const ModalHeader: (props: Props) => JSX.Element = (props: Props) => {
  const { onClose } = useNativeModalContext()

  return <Modal.Header {...props} onClose={onClose} />
}
